import { connectedRouterRedirect } from 'redux-auth-wrapper/history3/redirect';
import { routerActions } from 'react-router-redux';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import { apiCallIds } from '../api';
import { selectAccount } from '../ducks';

export default connectedRouterRedirect({
  authenticatedSelector: state => selectAccount(state) !== null,
  authenticatingSelector: state => selectIsInProgress(state, apiCallIds.LOGIN),
  redirectPath: '/auth/login',
  redirectAction: routerActions.replace,
  wrapperDisplayName: 'IsLoggedIn',
});



// WEBPACK FOOTER //
// ./src/features/auth/utils/IsLoggedIn.js